import { Domain } from "@modules/network/@types/Domain";
import NetworkThreatCard from "../../../components/cards/NetworkThreatCard";
import CardTitle from "../../../components/common/CardTitle";
import IocTable from "../../common/tables/IocTable";
import useEnrichedRelatedDomains from "../hooks/useEnrichedRelatedDomains";
import { schema } from "./schema";

type Props = Domain & {
  title?: string;
};

const RelatedDomainsCard = ({ domain, title }: Props) => {
  const { data, isPending, hasNextPage, fetchNextPage, isFetchingNextPage } =
    useEnrichedRelatedDomains({ domain });

  const entries = data?.pages?.flatMap(page => page.reports) ?? [];

  const handleNextPage = () => {
    if (!hasNextPage || isFetchingNextPage) return;
    fetchNextPage();
  };

  return (
    <NetworkThreatCard
      header={
        <NetworkThreatCard.Header
          title={<CardTitle label={title ?? "Related Domains"} />}
        />
      }
      contentClassName="p-0 flex flex-center justify-content-center"
      content={
        <IocTable
          schema={schema}
          data={entries}
          isLoading={isPending}
          isFetchingNextPage={isFetchingNextPage}
          hasMore={hasNextPage}
          onNextPage={handleNextPage}
        />
      }
    />
  );
};

export default RelatedDomainsCard;
